import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { Select, TSelectProps } from '../lib/Select';

interface ControlledSelectProps<T extends FieldValues>
  extends Omit<TSelectProps, 'name'> {
  name: Path<T>;
  control: Control<T>;
}

export const ControlledSelect = <T extends FieldValues>({
  name,
  control,
  ...props
}: ControlledSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restField } = field;

        return (
          <Select
            {...restField}
            {...props}
            ref={ref}
            error={!!error}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
